// extracted by mini-css-extract-plugin
export default {"Auth":"Auth_Auth__3EMLz","Auth__login":"Auth_Auth__login__LKzO0","Auth__text":"Auth_Auth__text__1KeYA","Auth__button":"Auth_Auth__button__Wm32t"};